export const hasPermission = (allowedMenus = [], moduleKey, role) => {
  if (!moduleKey) return true;
  if (role === 1) return true;
  if (!Array.isArray(allowedMenus) || allowedMenus.length === 0) return false;
  return allowedMenus.includes(moduleKey);
};

export const MENU_ROUTE_MAP = [
  { key: "dashboard", path: "/dashboard" },
  { key: "adminManagement", path: "/admin-management" },
  { key: "services.category", path: "/services/category" },
  { key: "services.subcategory", path: "/services/subcategory" },
  { key: "cms", path: "/cms-pages" },
  { key: "faq", path: "/faq-pages" },
  { key: "promoCodes", path: "/promo-codes" },
  { key: "email", path: "/email-management" },
  { key: "virtualToken", path: "/virtual-token" },
  { key: "events", path: "/event-table" },
  { key: "challenges", path: "/bet-management" },
  { key: "users.list", path: "/user-management" },
  { key: "users.top", path: "/top-user-management" },
  { key: "users.referral", path: "/referral-bonus-coins" },
  { key: "currencies", path: "/currencies" },
  { key: "tokens", path: "/token-transaction" },
  { key: "withdrawals", path: "/withdrawal-request" },
  { key: "commission", path: "/commission-history" },
  { key: "reports", path: "/reports-and-analytics" },
  { key: "tickets", path: "/ticket-support-management" },
  { key: "team", path: "/team-management" },
  { key: "system", path: "/system-settings" },
];

const DEFAULT_FALLBACK_ROUTE = "/dashboard";

export const getDefaultRouteForUser = (allowedMenus = [], role) => {
  if (role === 1) return DEFAULT_FALLBACK_ROUTE;

  for (const route of MENU_ROUTE_MAP) {
    if (hasPermission(allowedMenus, route.key, role)) {
      return route.path;
    }
  }

  return DEFAULT_FALLBACK_ROUTE;
};

